export default "__VITE_ASSET__BQFChBF5__"